var scope_0 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/40b28098743737fbfc22166b727dd799.js').default;
var scope_1 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    